import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const About: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section
      id="about"
      className={`about-section fade-in ${isVisible ? 'visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <h2 className="section-title">{t.about.title}</h2>
        <p className="about-text">
          {t.about.description}{' '}
          <strong>
            <a
              href={t.about.founders[0].linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.about.founders[0].name}
            </a>
          </strong>
          {t.about.suffix}
        </p>
        <div className="founders-grid">
          {t.about.founders.map((founder, index) => (
            <a
              key={index}
              href={founder.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="founder-card"
            >
              <img
                src={founder.image}
                alt={founder.alt}
                className="founder-image"
              />
              <div className="founder-info">
                <p className="founder-name">{founder.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;

